import React from 'react';

import AmenitiesEdit from './AmenitiesEdit';
import EditModalControl from '../common/edit/EditModalControl';

interface Props {
  type: 'button' | 'link';
  show?: boolean;
  onSuccess: () => void;
}

const AmenitiesEditModal = ({ type, show, onSuccess }: Props) => (
  <EditModalControl type={type} title={'Edit Amenities'} show={show} onSuccess={onSuccess}>
    <AmenitiesEdit />
  </EditModalControl>
);

export default AmenitiesEditModal;
